import { DateTime } from 'luxon'
import PointOfSale from '@/types/PointOfSale'

/**
 * Returns an array of POS sorted by the business rules for displaying them.
 *
 * Venda Online -> Custom (by creation date) -> Especiais
 *
 * @param posList an array of POSs
 * @returns a sorted array of POSs
 */
export default function sortPos(posList: PointOfSale[]): PointOfSale[] {
  const online: PointOfSale[] = []
  const especiais: PointOfSale[] = []
  const other: PointOfSale[] = []

  for (const pos of posList) {
    if (pos.online_sales) {
      online.push(pos)
      continue
    }

    if (pos.name === 'Especiais') {
      especiais.push(pos)
      continue
    }

    other.push(pos)
  }

  other.sort((a, b) => (DateTime.fromSQL(a.created_at) < DateTime.fromSQL(b.created_at) ? -1 : 1))

  return [...online, ...other, ...especiais]
}
